import { useQuery } from 'react-query'
import ApiClient from '../lib/api-client'

function fetchActionRequired () {
  return ApiClient.get('/community/action-required').then(data => data)
}

function useActionRequired (isEnabled = false) {
  return useQuery(
    'action-required',
    () => fetchActionRequired(),
    {
      enabled: isEnabled
    }
  )
}

export default useActionRequired
